import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import { LogEntry } from '../../stores/LogStore';

export const ScenarioModePropTypes =
  PropTypes.shape({
    budgetConstraint: PropTypes.shape({
      type: PropTypes.string,
      percent: PropTypes.number,
    }),
    cost: PropTypes.number,
    discountFactor: PropTypes.number,
    flightSize: PropTypes.number,
    frequencyCap: PropTypes.number,
    key: PropTypes.string,
    relativeImpact: PropTypes.number,
  });

export const ScenarioParametersPropTypes =
  PropTypes.shape({
    jobDiscount: PropTypes.number,
    modes: PropTypes.arrayOf(ScenarioModePropTypes),
    runName: PropTypes.string,
    targetUniverse: PropTypes.string,
    totalBudget: PropTypes.number,
    upliftScore: PropTypes.string,
  });

export const ScenarioPropTypes =
  PropTypes.shape({
    id: PropTypes.string,
    lastRun: PropTypes.shape({
      finishedAt: PropTypes.instanceOf(moment),
      id: PropTypes.string,
      scenarioId: PropTypes.string,
      startedAt: PropTypes.instanceOf(moment),
      status: PropTypes.String,
    }),
    name: PropTypes.string,
    organizationId: PropTypes.number,
    parameters: ScenarioParametersPropTypes,
    totalBudget: PropTypes.number,
    runs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
    })),
    status: PropTypes.string,
  });

export const QueryPropTypes =
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    sql: PropTypes.string,
    tags: PropTypes.array,
  });

export const LogsPropTypes =
  PropTypes.shape({
    logs: ImmutablePropTypes.iterableOf(
      PropTypes.instanceOf(LogEntry),
    ),
  });

export const OrganizationPropTypes =
  PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    defaultTableauUser: PropTypes.string,
  });

export const JobTaskPropTypes =
  PropTypes.shape({
    jobType: PropTypes.string,
    config: PropTypes.object,
  });

export const JobPropTypes =
  PropTypes.shape({
    name: PropTypes.string,
    config: PropTypes.oneOfType([
      ImmutablePropTypes.iterableOf(JobTaskPropTypes),
      PropTypes.object,
    ]),
    runAsUserEmail: PropTypes.string,
    scheduleCron: PropTypes.string,
  });
